module.exports = __webpack_public_path__ + "img/logo1.279afdf9.png";